import {Injectable} from "@angular/core";
import {DxListDatasource} from "../../../dx-lists/domain/list/dx-list-datasource";
import {DxListItemDataProvider} from "../../../dx-lists/domain/list/dx-list-item-data-provider";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {HttpResponse} from "@angular/common/http";
import {BdpkConfigService} from "../../../bdpk-common/services/bdpk-config.service";
import {DxObjectMapper} from "../../../dx-core/services/dx-object-mapper.service";
import {DxHttpDispatcher} from "../../../dx-core/services/dx-http-dispatcher.service";
import {PitFilterTreeNode} from "../../domain/filter-tree/pit-filter-tree-node";
import {DxTreeListItemDataProvider} from "../../../dx-lists/domain/tree-list/dx-tree-list-item-data-provider";
import {fromPromise} from "rxjs/internal-compatibility";


@Injectable()
export class PitFilterTreeService implements DxListDatasource {

  constructor(private _configService: BdpkConfigService,
              private _mapper: DxObjectMapper,
              private _http: DxHttpDispatcher) {
  }


  public fetch(id: number): Observable<DxListItemDataProvider> {
    const promise = new Promise<PitFilterTreeNode>((resolve, reject) => {
      this._http
        .get('activities-filter-tree')
        .subscribe(response => {
          const activities = this._mapper.deserializeASArray<PitFilterTreeNode>(response.body, PitFilterTreeNode);
          const activity = activities.find(item => item.id === id);
          if(activity) {
            resolve(activity);
          } else {
            reject(`Задача с id ${id} не найдена!`);
          }
        }, errorResponse => {
          reject(DxHttpDispatcher.handleHttpError(errorResponse));
        });
    });
    return fromPromise<PitFilterTreeNode>(promise);
  }

  public fetchAll(filter?: Map<string, Object>, sorts?: Map<string, string>): Observable<DxTreeListItemDataProvider[]> {
    /*return this._http.get('activities-filter-tree').pipe(
      map((response: HttpResponse<any>) => {
        return this._mapper.deserializeASArray<PitFilterTreeNode>(response.body, PitFilterTreeNode);
      }));*/
    let filterTree: object = {presetViewId: 1};
    if (filter && filter.get('FILTER_TREES')) filterTree = filter.get('FILTER_TREES');
    let path: string = this._configService.pitBackendActivitiesEndPoint + '/filter-trees/'+filterTree['presetViewId'];
    return this._http.get(path).pipe(
      map((response: HttpResponse<any>) => {
        let tree: any = response.body;
        return this._mapper.deserializeASArray<PitFilterTreeNode>(tree.nodes, PitFilterTreeNode);
      }));
  }


  public delete(id: number): Observable<number> {
    const promise = new Promise<number>((resolve, reject) => {
      setTimeout(() => {
        resolve(id);
      }, 100);
    });
    return fromPromise<number>(promise);
  }

  public deleteAll(ids: number[]): Observable<number[]> {
    const promise = new Promise<number[]>((resolve, reject) => {
      setTimeout(() => {
        resolve(ids);
      }, 100);
    });
    return fromPromise<number[]>(promise);
  }


  public save(item: DxListItemDataProvider): Observable<DxListItemDataProvider> {
    const promise = new Promise<DxListItemDataProvider>((resolve, reject) => {
      setTimeout(() => {
        (<PitFilterTreeNode> item).id = PitFilterTreeService.generateId();
        resolve(item);
      }, 100);
    });
    return fromPromise<DxListItemDataProvider>(promise);
  }

  public saveAll(items: DxListItemDataProvider[]): Observable<DxListItemDataProvider[]> {
    const promise = new Promise<DxListItemDataProvider[]>((resolve, reject) => {
      setTimeout(() => {
        items.forEach(item => {
          (<PitFilterTreeNode> item).id = PitFilterTreeService.generateId();
        });
        resolve(items);
      }, 100);
    });
    return fromPromise<DxListItemDataProvider[]>(promise);
  }


  public update(item: DxListItemDataProvider): Observable<DxListItemDataProvider> {
    const promise = new Promise<DxListItemDataProvider>((resolve, reject) => {
      setTimeout(() => {
        resolve(item);
      }, 100);
    });
    return fromPromise<DxListItemDataProvider>(promise);
  }

  public updateAll(items: DxListItemDataProvider[]): Observable<DxListItemDataProvider[]> {
    const promise = new Promise<DxListItemDataProvider[]>((resolve, reject) => {
      setTimeout(() => {
        resolve(items);
      }, 100);
    });
    return fromPromise<DxListItemDataProvider[]>(promise);
  }


  public static generateId(): number {
    return Math.round((new Date().getTime() / 1000) * Math.random());
  }
}
